import customNav from './customNav';

export function mainLocalCode() {
  $(document).ready(function () {
    $('.generalmessage').prependTo('header');
    customNav();
    createCustomTicket();
    createBurgerIcon();
  });

  // =======================
  // Custom ticket button
  function createCustomTicket() {
    $('.header .ticket')
      .removeClass('ticket')
      .addClass('custom-tkt-btn')
      .text('Buy Tickets')
      .css('opacity', 1);
  }

  // =======================
  // Custom burger menu
  function createBurgerIcon() {
    $.each(new Array(3), function () {
      $('.header .mobile-nav-toggle').append('<span class="toggle-bar">');
    });
  }
}

// function to validate class
export function classValidation(className) {
  return $('body').hasClass(className);
}
